import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RoomIdService } from './room-id.service';
import { UserService } from '../user/user.service';
import { AuthService } from '../user/auth.service';
import { UIMesageService } from '../common/ui-message.service';
import { NGXLogger as LoggerService } from "ngx-logger";
import { ResponsiveService } from '../common/responsive.service';
import { EstimateService } from './estimate.service';
import { GoogleAnalyticsService } from '../common/google-analytics.service';
import { MatDialog } from '@angular/material/dialog';
//declare const window: any;

@Component({
    selector: 'poker-room-premium',
    templateUrl: './poker-room-premium.component.html',
    styleUrls: ['./poker-room-premium.component.scss'],

})

export class PokerRoomPremiumComponent implements OnInit, OnDestroy {
    constructor(
        private route: ActivatedRoute,
        public roomIdService: RoomIdService,
        public userService: UserService,
        public authService: AuthService,
        private uiMessage: UIMesageService,
        private logger: LoggerService,
        public responsiveService: ResponsiveService,
        public estimateService: EstimateService,
        private googleAnalyticsService: GoogleAnalyticsService,
        public dialog: MatDialog
    ) {
    }
    ngOnDestroy(): void {
    }

    async ngOnInit() {
        try {
        } catch (error) {
            this.uiMessage.error(error, 'Initializing the room. Please check your internet connection.');
        }
    }




}
